import { render, staticRenderFns } from "./imglist.vue?vue&type=template&id=35c163a8&"
import script from "./imglist.vue?vue&type=script&lang=js&"
export * from "./imglist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports